import { getViewConfiguration } from './getViewConfiguration';
import type { PortalViewId } from './portalViewIds';
import type { DisplayContext, DisplayDecision, PortalUser } from './types';

const meetsLegacyVisibilityRule = (
  portalUser: PortalUser,
  legacyVisibilityPermissions?: readonly string[]
): boolean => {
  if (!legacyVisibilityPermissions?.length) {
    return true;
  }

  return legacyVisibilityPermissions.some((permission) =>
    portalUser.permissions.includes(permission)
  );
};

const evaluateLegacy = (portalUser: PortalUser, context?: DisplayContext): DisplayDecision => {
  if (meetsLegacyVisibilityRule(portalUser, context?.legacyVisibilityPermissions)) {
    return { shouldDisplay: true };
  }

  return { shouldDisplay: false, reason: 'legacy-rule-not-met' };
};

export function getDisplayDecision(
  portalUser: PortalUser,
  viewId?: PortalViewId,
  context?: DisplayContext
): DisplayDecision {
  if (context?.exemptFromViewConfiguration) {
    return evaluateLegacy(portalUser, context);
  }

  const viewConfiguration = getViewConfiguration(portalUser);
  if (viewConfiguration) {
    if (viewId && viewConfiguration.viewIds.includes(viewId)) {
      return { shouldDisplay: true };
    }

    return { shouldDisplay: false, reason: 'not-configured' };
  }

  return evaluateLegacy(portalUser, context);
}
